import { render, staticRenderFns } from "./UserPlaylists.vue?vue&type=template&id=00c7d7ee&"
import script from "./UserPlaylists.vue?vue&type=script&lang=js&"
export * from "./UserPlaylists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports